<template>
  <BarChart
    v-if="Object.keys(wordViews).length > 0"
    class="chart-container"
    :chartdata="chartDataWordViews()"
    :options="wordviewOptions"
  />
</template>

<script>
import BarChart from "@/components/chart/BarChart";
import BarChartCommons from "@/components/chart/BarChartCommons";

function __colorPaletteWordViews(context) {
  const cols = [
    "#ff1744",
    "#d500f9",
    "#651fff",
    "#3d5afe",
    "#2979ff",
    "#00b0ff",
    "#00e5ff",
    "#1de9b6",
    "#00e676",
    "#76ff03",
    "#c6ff00",
    "#ffea00",
    "#ffc400",
    "#ff9100",
    "#ff3d00"
  ];
  const index = context.dataIndex;
  return cols[index % cols.length] + "7C";
}

export default {
  name: "BoxWordStatisticsWordviewChart",
  components: { BarChart },
  props: {
    wordViews: {
      type: Object,
      required: true
    },
    cards: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    wordviewOptions: {
      ...BarChartCommons.defaultChartOptions({
        xAxes: { ticks: { stepSize: 1, beginAtZero: true } }
      })
    }
  }),
  methods: {
    chartDataWordViews: function() {
      const data = {
        labels: [],
        datasets: [
          {
            barThickness: "flex",
            barPercentage: 0.99,
            borderColor: "rgba(0, 0, 0, 0.2)",
            borderWidth: 1,
            backgroundColor: __colorPaletteWordViews,
            data: []
          }
        ]
      };

      const words = this.wordViews;
      Object.keys(words).forEach(w => {
        data.labels.push(w + ": " + words[w]);
        data.datasets[0].data.push(words[w]);
      });

      return data;
    }
  }
};
</script>

<style></style>
